exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".aeris-cartouche-host{display:inline-block}.aeris-cartouche-container{display:inline-block;padding:2px 5px;margin:0 3px;border:1px solid #f5f5f5;border-radius:5px!important;color:#666;background-color:#f5f5f5}.aeris-cartouche-container:hover{cursor:default}.aeris-cartouche-container .fa{margin-right:5px}.aeris-cartouche-delete{cursor:pointer;margin-left:3px;opacity:.6}.aeris-cartouche-delete:hover{opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-190dd651","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/aeris-cartouche/aeris-cartouche.vue
// module id = 157
// module chunks = 0